<template>
  <div>
    <van-sticky>

      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">体测信息</div>
      </nav-bar>

      <van-empty v-if="!status" description="暂无体测数据"/>

      <van-row style="margin-top: 50px" v-if="violation||cheat" type="flex" justify="center">
        <van-col span="30">
          <van-icon :color="'#ee0a24'" size="10rem" :name="'cross'"/>
        </van-col>
      </van-row>
      <van-row style="color: #ee0a24;font-size: 30px" type="flex" justify="center">
        <van-col v-if="violation" span="30">
          体测违规，成绩无效
        </van-col>
        <van-col v-if="cheat" span="30">
          体测替考，成绩无效
        </van-col>
      </van-row>

    </van-sticky>

    <van-cell-group v-if="status&&!violation&&!cheat">
      <van-cell title="学籍号" :value="info.snum"/>
      <van-cell title="姓名" :value="info.sname"/>
      <van-cell title="性别" :value="info.gender"/>
      <van-cell title="身高(cm)" :value="info.height"/>
      <van-cell title="体重(kg)" :value="info.weight"/>
      <van-cell title="肺活量(ml)" :value="info.vitalCapacity"/>
      <van-cell title="50米跑(秒)" :value="info.fm"/>
      <van-cell title="立定跳远(cm)" :value="info.sj"/>
      <van-cell title="坐位体前屈(cm)" :value="info.sfb"/>
      <van-cell v-if="info.gender=='女'" title="800米跑" :value="info.ehm"/>
      <van-cell v-if="info.gender=='男'" title="1000米跑" :value="info.ok"/>
      <van-cell v-if="info.gender=='女'" title="仰卧起坐(个)" :value="info.su"/>
      <van-cell v-if="info.gender=='男'" title="引体向上(个)" :value="info.pu"/>
      <van-cell title="身高体重分数" :value="info.hwScore"/>
      <van-cell title="肺活量分数" :value="info.vcScore"/>
      <van-cell title="50米分数" :value="info.fmScore"/>
      <van-cell title="立定跳分数" :value="info.sjScore"/>
      <van-cell title="坐位体分数" :value="info.sfbScore"/>
      <van-cell title="800米/1000米分数" :value="info.eokScore"/>
      <van-cell title="仰卧/引体分数" :value="info.spScore"/>
      <van-cell title="总分" :value="info.total"/>
      <van-cell title="分数等级" :value="info.ranks"/>
    </van-cell-group>

  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar";
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Field,
  Popup,
  Picker,
  Cell,
  Button,
  PullRefresh,
  List,
  SwipeCell,
  Toast, Dialog,
  ActionSheet,
  NoticeBar,
  Sticky,
  Empty,
  Row,
  Col,
  Icon,
  CellGroup
} from 'vant';


Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Cell);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Sticky);
Vue.use(Empty);
Vue.use(Row);
Vue.use(Col);
Vue.use(Icon);
Vue.use(CellGroup);
import {GetPhysicalTestInfo} from "@/network/student";

export default {
  name: "PhysicalTestQuery",
  components: {
    NavBar
  },
  data() {
    return {
      status: false,
      violation: false,
      cheat: false,
      info: null,
    }
  },
  mounted() {
    GetPhysicalTestInfo().then(res => {
      console.log(res);
      this.status = res.status;
      this.violation = res.violation;
      this.cheat = res.cheat;
      this.info = res.test;
    })
  },
  methods: {
    onClickLeft() {
      this.$router.replace("/home");
    }
  }
}
</script>

<style scoped>

</style>
